import { useMediaQuery } from '@vueuse/core'
import { reactive } from 'vue'
import { screens } from 'windiconfig/theme'

export type Breakpoint = keyof typeof screens

export type MediaQueries = {
  [BreakpointKey in Breakpoint]: string
} & {
  landscape: string
  portrait: string
}

export type MediaQueriesMatch = {
  [Key in keyof MediaQueries]: boolean
}

export const mediaQueries = Object.entries(screens).reduce((acc, [name, size]) => {
  let mediaQuery
  if (typeof size === 'string') {
    mediaQuery = `(min-width: ${size})`
  } else if (size.max && size.min) {
    mediaQuery = `(max-width: ${size.max}) and (min-width: ${size.min})`
  } else {
    mediaQuery = `(max-width: ${size.max})`
  }
  acc[name] = mediaQuery
  return acc
}, {
  landscape: '(orientation: landscape)',
  portrait: '(orientation: portrait)'
}) as MediaQueries

export const useBreakpoint = () => {
  const matches = reactive({})

  Object.entries(mediaQueries).forEach(([name, mediaQuery]) => {
    matches[name] = useMediaQuery(mediaQuery)
  })

  return matches as MediaQueriesMatch
}
